// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';

import demandCollectionActionTypes from './demand-collection.types';
import {
	fetchDemandLoanList,
	demandCollectionRevertAPI,
	updateThriftPaidAPI,
} from './demand-collection.service';

import {
	fetchDemandMemberLoanInfoSuccess,
	fetchDemandMemberLoanInfoFailure,
	fetchDemandMemberLoanInfoResponseChanged,
	updateDemandCollectionRevertResponseChanged,
	updateDemandCollectionRevertSuccess,
	updateDemandCollectionRevertFailure,
	updateThriftPaidSuccess,
	updateThriftPaidFailure,
	updateThriftPaidResponseChanged,
} from './demand-collection.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START MEMBER LOAN LIST DETAILS  ******************** */
export function* getDemandMemberLoanList({ payload }: any) {
	try {
		const {
			officerID,
			databaseName,
			demandDate,
			companyID,
			branchID,
			centerID,
			groupID,
			userLevel,
			userID,
		} = payload;
		const key = 'FetchDemandForTodayCollectionKey';
		const jsonData = {
			GroupOfficerID: officerID,
			DatabaseName: databaseName,
			RepayDate: demandDate,
			FromDate: demandDate,
			ToDate: demandDate,
			CompanyID: companyID,
			BranchID: branchID,
			LocationID: centerID,
			GroupID: groupID,
			UserLevel: userLevel,
			UserID: userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchDemandLoanList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchDemandMemberLoanInfoFailure(responseData.data));
		} else {
			yield put(fetchDemandMemberLoanInfoSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchDemandMemberLoanInfoFailure(error));
	}
}

export function* resetGetDemandMemberLoanListResponse() {
	yield put(fetchDemandMemberLoanInfoResponseChanged());
}

export function* onGetDemandMemberLoanListDetails() {
	yield takeLatest(
		demandCollectionActionTypes.GET_DEMAND_LOAN_LIST_START,
		getDemandMemberLoanList,
	);
}

export function* onGetDemandMemberLoanListResponseReset() {
	yield takeLatest(
		demandCollectionActionTypes.GET_DEMAND_LOAN_LIST_RESPONSE_RESET,
		resetGetDemandMemberLoanListResponse,
	);
}
/** *********************  END GET MEMBER LOAN LIST  ******************** */

/** *********************  START DEMAND COLLECTION REVERT  ******************** */
export function* revertDemandCollectionList({ payload }: any) {
	try {
		const {
			officerID,
			databaseName,
			loanIndexGroupMemberIDs,
			companyID,
			branchID,
			centerID,
			groupID,
			userName,
			userID,
			collectionDate,
		} = payload;
		const key = 'RevertDemandForTodayCollectionKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			BranchID: branchID,
			OfficerID: officerID,
			CollectionDate: collectionDate,
			ToDate: collectionDate,
			CenterID: centerID,
			RepayDate: collectionDate,
			GroupID: groupID,
			UserID: userID,
			UserName: userName,
			LoanIndexGroupMemberIDs: loanIndexGroupMemberIDs,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(demandCollectionRevertAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateDemandCollectionRevertFailure(responseData.data));
		} else {
			yield put(updateDemandCollectionRevertSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateDemandCollectionRevertFailure(error));
	}
}

export function* resetDemandCollectionRevertResponse() {
	yield put(updateDemandCollectionRevertResponseChanged());
}

export function* onDemandCollectionRevert() {
	yield takeLatest(
		demandCollectionActionTypes.UPDATE_DEMAND_COLLECTION_REVERT_START,
		revertDemandCollectionList,
	);
}

export function* onDemandCollectionRevertResponseReset() {
	yield takeLatest(
		demandCollectionActionTypes.UPDATE_DEMAND_COLLECTION_REVERT_RESPONSE_RESET,
		resetDemandCollectionRevertResponse,
	);
}
/** *********************  END DEMAND COLLECTION UPDATE  ******************** */

/** *********************  START UPDATE THRIFT PAID  ******************** */
export function* updateThriftPaid({ payload }: any) {
	try {
		const {
			officerID,
			databaseName,
			companyID,
			branchID,
			centerID,
			groupID,
			userName,
			userID,
			collectionDate,
			thriftArray,
		} = payload;
		const key = 'UpdateThriftPaidKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			BranchID: branchID,
			OfficerID: officerID,
			CollectionDate: collectionDate,
			ToDate: collectionDate,
			CenterID: centerID,
			RepayDate: collectionDate,
			GroupID: groupID,
			UserID: userID,
			UserName: userName,
			ThriftArray: thriftArray,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateThriftPaidAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateThriftPaidFailure(responseData.data));
		} else {
			yield put(updateThriftPaidSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateThriftPaidFailure(error));
	}
}

export function* resetUpdateThriftPaidResponse() {
	yield put(updateThriftPaidResponseChanged());
}

export function* onUpdateThriftPaid() {
	yield takeLatest(demandCollectionActionTypes.UPDATE_THRIFT_PAID_START, updateThriftPaid);
}

export function* onUpdateThriftPaidResponseReset() {
	yield takeLatest(
		demandCollectionActionTypes.UPDATE_THRIFT_PAID_RESPONSE_RESET,
		resetUpdateThriftPaidResponse,
	);
}
/** *********************  END UPDATE THRIFT PAID  ******************** */

export function* demandCollectionSaga() {
	yield all([
		call(onGetDemandMemberLoanListDetails),
		call(onGetDemandMemberLoanListResponseReset),
		call(onDemandCollectionRevert),
		call(onDemandCollectionRevertResponseReset),
		call(onUpdateThriftPaid),
		call(onUpdateThriftPaidResponseReset),
	]);
}
